import GenericEventBody from '../../EventDetailBody/GenericEventBody.jsx';
import { ClaimsList } from '../shared/index.js';

/**
 * Gov Promotion detail body: situation, pipeline, destination, and extracted
 * claims. The decision controls live in the shared pinned footer.
 */
function GovPromotionBody({ event }) {
  return (
    <div className="flex flex-col gap-5">
      <GenericEventBody event={event} flush />
      <ClaimsList event={event} titleKey="govPromotion.claimsExtracted" />
    </div>
  );
}

export default GovPromotionBody;
